module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-192x192-8fe77ad905a2ef4ca5e5b59f204ce0fa.png";